import { render, staticRenderFns } from "./CrearDescuento.vue?vue&type=template&id=48b78124&scoped=true&"
import script from "./CrearDescuento.vue?vue&type=script&lang=js&"
export * from "./CrearDescuento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b78124",
  null
  
)

export default component.exports